import type { LeadAppointmentFormFields } from './lead-appointment-form.interface';

export const LeadAppointmentFormDefaults: {
  fields: { [Key in keyof LeadAppointmentFormFields]: string };
} = {
  fields: {
    DayLabel: 'Datum',
    DayRequiredError: 'Datum is verplicht',
    TimeLabel: 'Tijdstip',
    TimeRequiredError: 'Tijdstip is verplicht',
  },
};
